// iOS deeplink redirect helper.
//
// Telegram iOS WebView silently drops navigation to non-http(s) schemes
// that aren't in the per-mini-app `allowedProtocols` server-side whitelist
// (see Telegram-iOS WebAppController.swift). Until `happ` is whitelisted
// for our bot, a direct `<a href="happ://...">` click is dead on arrival.
//
// Workaround: open an HTTPS redirect page at `/r/happ.html` via
// WebApp.openLink, which Telegram iOS hands off to Safari. Safari has no
// scheme whitelist and surfaces the OS-native "Open in Happ?" prompt
// from a `location.replace('happ://...')` inside the redirect page.

// URL of the static redirect page that fires the happ:// deeplink from
// Safari. The page lives at `miniapp/public/r/happ.html`; nginx serves
// it verbatim before falling through to the SPA. Using
// `window.location.origin` keeps this working across dev, staging and
// prod without env config.
export function happRedirectURL(subscriptionUrl: string): string | null {
  const trimmed = subscriptionUrl.trim();
  if (!trimmed) return null;
  if (!trimmed.toLowerCase().startsWith('https://')) return null;
  return `${window.location.origin}/r/happ.html?sub=${encodeURIComponent(trimmed)}`;
}
